import React, { FC } from "react";

import {
  Button,
  Icon,
  InformationItem,
  Modal,
} from "../../../components/common";

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const HowToSetupWalletModal: FC<Props> = ({ isOpen, close }) => {
  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title={
        <div className="flex flex-col gap-6">
          <Button
            className="!w-6 !h-6 hidden md:flex"
            icon
            variant={Button.variant.TERTIARY}
            size={Button.size.SMALL}
            onClick={close}
          >
            <Icon icon="Arrow-left" size={24} />
          </Button>

          <h2>How to set up wallet</h2>
        </div>
      }
    >
      <div className="flex flex-col gap-12">
        <InformationItem
          icon="telegram_fill"
          iconPosition="top"
          title="We can’t create a wallet for you, but you can do it in Telegram within couple minutes"
          description={
            <>
              <p className="mt-2">
                Just Go directly to Telegram's Wallet Bot{" "}
                <a
                  className="text-purple-700"
                  href="https://t.me/wallet"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://t.me/wallet
                </a>
                . It will take a minute or two. And come back to add wallet
                details here.
                <br />
                <br />
                You can read more about Stablecoin in{" "}
                <a
                  className="text-purple-700"
                  href="https://archway.finance/blog/navigating-stablecoins-understanding-usdt-for-secure-and-stable-settlements"
                  target="_blank"
                  rel="noreferrer"
                >
                  Archway blog
                </a>
              </p>
            </>
          }
        />

        <div className="flex justify-center">
          <Button
            className="px-5 contact-support-btn"
            contentClassName="flex gap-5"
            variant={Button.variant.PRIMARY}
          >
            Get Help{" "}
            <Icon
              icon="support_agent"
              size={24}
              className="text-white"
              disableFill
            />
          </Button>
        </div>
      </div>
    </Modal>
  );
};
